import { Stack, StackProps } from "@aksara-ui/react";
import * as React from "react";

export interface ActionListProps
  extends StackProps,
    React.ComponentPropsWithoutRef<"div"> {}

const ActionList = React.forwardRef<HTMLDivElement, ActionListProps>(
  ({ children, ...rest }, ref) => {
    return (
      <Stack
        display="block"
        spacing="xxs"
        borderRadius="lg"
        paddingY="sm"
        backgroundColor="#FFFFFF"
        ref={ref}
        _focusVisible={{
          outline: "0px",
        }}
        {...rest}
      >
        {children}
      </Stack>
    );
  }
);

export default ActionList;
